export default import.meta.ROLLDOWN_FILE_URL_5MsUoxbihf6xMn1vygCl5g